import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DivestmentStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-divestmentstatus-container',
  templateUrl: './divestmentstatus-container.component.html',
  styleUrls: ['./divestmentstatus-container.component.scss']
})
export class DivestmentStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  divestmentstatuss$: Observable<DivestmentStatusDto[]>;
  loading: boolean;
  isLoadingDivestmentStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingDivestmentStatus$ = this.gatwayFacade.isLoadingGateway("DivestmentStatus");
    this.divestmentstatuss$ = this.gatwayFacade.loadGateway("DivestmentStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDivestmentStatus(deletedValue: any) {
    this.gatwayFacade.remove("DivestmentStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitDivestmentStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.DivestmentStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllDivestmentStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllDivestmentStatus.push(pullData[i]);
    }
  }

// check if the addAllDivestmentStatus array is not empty, then dispatch the data to the store
   if(addAllDivestmentStatus.length > 0) {
    this.gatwayFacade.add('DivestmentStatus', addAllDivestmentStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('DivestmentStatus', allUpdates, ['id']);
  }

   }


}
